import { Warning } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import type { CrmEnrichmentJobRunOutcome } from "../../types/types";

import { StyledErrorBannerFlex, StyledErrorBannerText } from "./styles";

type Props = {
    lastRunOutcome?: CrmEnrichmentJobRunOutcome | null;
    onViewLogFile: () => void;
};

const CrmEnrichmentJobRunErrorBanner = ({ lastRunOutcome, onViewLogFile }: Props) => {
    if (lastRunOutcome !== "failed" && lastRunOutcome !== "partiallyFailed") {
        return null;
    }

    const variant = lastRunOutcome === "failed" ? "error" : "warning";
    const messageKey =
        lastRunOutcome === "failed"
            ? "si.crm-enrichment.job.banner.error"
            : "si.crm-enrichment.job.banner.partial-error";

    return (
        <StyledErrorBannerFlex
            alignItems="center"
            justifyContent="space-between"
            $variant={variant}
            data-automation="enrichment-job-error-banner"
        >
            <StyledErrorBannerText $variant={variant}>
                <Warning size="xs" />
                {translate(messageKey)}
            </StyledErrorBannerText>

            <IconButton
                iconName="download"
                type="flatDark"
                dataAutomation="enrichment-job-error-banner-download-button"
                onClick={onViewLogFile}
            >
                {translate("si.crm-enrichment.job.banner.view-log-file")}
            </IconButton>
        </StyledErrorBannerFlex>
    );
};

export default CrmEnrichmentJobRunErrorBanner;
